<!-- <div class="grid"> -->

    <!-- <div class="col-12"> -->
        <p-card header="Artifacts" subheader="" class="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="grid col-9">

                <div class="grid col-1 full-width" >

                    <div class="col-3">
                        <label for="dateFrom" class="margin-right">Date From:</label>
                        <p-datePicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" 
                        [showIcon]="true" class="margin-left" (ngModelChange)="onDateChange($event, 'selectedDateFrom')"></p-datePicker>
                    </div>
    
                    <div class="col-3">
                        <label for="dateTo" class="margin-left">Date To:</label>
                        <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo"  dateFormat="yy-mm-dd" 
                           [showIcon]="true" class="margin-left" (ngModelChange)="onDateChange($event, 'selectedDateTo')"></p-datePicker>
                    </div>

                    <div class="col-3">
                        <label for="artifactTypes">Artifact Type:</label>
                      
                        <p-select id ="artifactTypes" [options]="artifactTypes" [(ngModel)]="selectedArtifactType" [filter]="true" 
                            class="prime-dropdown" placeholder="artifact types:" [editable]="false"  class="margin-left" [style]="{'width':'50%'}">
                        </p-select>
                    </div>

    
                    
                    <div class="col-1">
                        <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
                        <!-- <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)"></p-button> -->
                    </div>
    
                    <div class="col-1" id="idSpinner" [hidden]="isSpinnerHidden">
                    <div class="loader"></div>  
                    </div>

                </div>


            </div>  


            <!--  G R I D  -->
            
            <div class="grid col-10">
                <p-table #gridData [columns]="artifactGridCols" [value]="artifacts" selectionMode="single"  
                    class="p-datatable-striped p-datatable-sm wal-table"
                     [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true" dataKey="artifactSessionId"
                    sortMode="multiple"  [paginator]="true" [rows]="pageSize">
                    <ng-template pTemplate="caption">
                        Artifacts
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                            @for (col of columns; track col.field) {
                                <th [pSortableColumn]="col.field"
                                    [style.display]="col.display"
                                    [style.width]="col.width">
                                    {{ col.header }}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </th>
                            }
                        </tr>

                        <tr>
                            @for (col of columns; track col.field) {
                                <th [style.width]="col.width" [style.display]="col.display">
                                    @switch (col.field) {
                                        @case ('artifactName') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="gridData.filter(($any($event.target)).value, col.field, 'contains')"
                                            />
                                        }
                                        @case ('artifactDescription') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="gridData.filter(($any($event.target)).value, col.field, 'contains')"
                                            />
                                        }
                                        @case ('artifactStatus') {
                                            <ng-container>
                                                <p-multiSelect
                                                [options]="artifactStatusOptions"
                                                [(ngModel)]="selectedArtifactStatuses"
                                                (onChange)="onArtifactStatusFilterChange()"
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="Filter Status"
                                                [style]="{'width': '200px'}">
                                                </p-multiSelect>
                                            </ng-container>                                        }
                                        @default {
                                        }
                                    }
                                </th>
                            }

                        </tr>
                      </ng-template>
                      
                      <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pEditableRow]="rowData">
                            <td *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'display': col.display}">
                                @if(col.field === 'artifactRequestedTime') {
                                    <span>{{ rowData[col.field] | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
                                }
                                @if(col.field === 'artifactStatus') {
                                    <span>{{ formatArtifactStatus(rowData[col.field]) }}</span>
                                }
                                @if(col.field !== 'artifactStatus' && col.field !== 'artifactRequestedTime') {
                                    <span>{{ rowData[col.field] }}</span>
                                }
                                @if (col.field === 'download' && rowData.artifactStatus === 'ARTIFACT_DELIVERED' && rowData.artifactLocation != null) {
                                    <span style="text-align:center">
                                        <button  pButton type="button" icon="pi pi-download" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                            data-toggle="tooltip" data-placement="top" title="Download previously generated artifact" 
                                            class="ui-button-info" (click)="onFileDownload(rowData)">
                                        </button>
                                    </span>
                                }
                            </td>
                            
                        </tr>
                      </ng-template> 
                    <!-- Empty Message Template -->
                    <ng-template pTemplate="emptymessage">
                        <tr>
                        <td [attr.colspan]="artifactGridCols.length + 1" style="text-align: center;">
                            <strong>No data found</strong>
                        </td>
                        </tr>
                    </ng-template>

                </p-table> 

            </div>

           
        </p-card>
    <!-- </div>             -->


<!-- </div>     -->


<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="my-generated-artifacts"></p-confirmDialog>